export enum UBSGenderEnum
{
    maleCis = 2,
    famaleCis = 3,
    maleTrans = 5,
    femaleTrans = 6,
    travesti = 7,
    nonBinary = 8,
    notInformed = 4
}